module.exports = __webpack_public_path__ + "static/media/mysql.3902d78d.png";